module.exports = __webpack_public_path__ + "img/partA1.e700e2ee.png";